const state = {}

const mutations = {}

const actions = {}

const getters = {}

import exits from './modules/exits.js';
import lopsandrlops from './modules/lopsandrlops.js';
import variableearnings from './modules/variableearnings.js';
import tds from './modules/tds.js';
import paygroups from './modules/paygroups.js';
import runpayroll from './modules/summary.js';
import selectedemployee from './modules/selectedemployee.js';


export default {
    namespaced: true,
    state,
    mutations,
    actions,
    getters,
    modules: {
        exits: exits,
        lopsandrlops: lopsandrlops,
        variableearnings: variableearnings,
        tds: tds,
        paygroups: paygroups,
        runpayroll: runpayroll,
        selectedemployee: selectedemployee
    }
};